module.exports = __webpack_public_path__ + "144c21f0595adc219053d20be55a12f6.png";